import axios from "axios";
import { useQuery } from "react-query";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getFranchiseeOwners = async () => {
  const { data } = await axios.get(`${api_base_url}/Report/FranchiseeOwners`);
  return data;
};

export const useGetFranchiseeOwners = () => {
  return useQuery("FranchiseeOwners", getFranchiseeOwners, {
    refetchOnWindowFocus: false,
  });
};
